<script>
  import { createEventDispatcher } from "svelte";
  import { ProviderName,IsAuthConfigValid } from "../store.js";
  import wrappedFetch from "../../../wrappedFetch.js";
  import ProviderBlock from "./provider-block.svelte";
  import Router from "../../../router.js";
  import Confirm from "./../../components/modalconfirm.svelte";
  let providerName = "";
  let dispatch = new createEventDispatcher();
  let showConfirm = false;
  let data = {};
  let isButtonLoading = [];  

  const onMisSelect = async (source) => {
    isButtonLoading[source] = true;
    data.source = source;
    let resp = await wrappedFetch(
      `/api/import/EnableProvider?providerName=${source}`,
      {
        method: "post",
      }
    );

    providerName = await resp.text();
    providerName = providerName.toLowerCase();

    ProviderName.set(providerName);
    dispatch("misSelected");
    IsAuthConfigValid.set(false);
    isButtonLoading[source] = false;
    Router.route(`/app/import/step2`, false);
  };
  const onChangeMIS = () => {
    ProviderName.set("");
    showConfirm = false;
    Router.route(`/app/import/step1`, false);
  };
</script>

{#if $ProviderName == ''}
<div class="row">
  <ProviderBlock provider="sims" bind:isButtonLoading={isButtonLoading['SIMS']} on:select={onMisSelect.bind(this, 'SIMS')} />
  <ProviderBlock
  provider="integris g2"
  bind:isButtonLoading={isButtonLoading['Integris G2']}
  on:select={onMisSelect.bind(this, 'Integris G2')} />
</div>
<br>
  <div class="row">
    <ProviderBlock
      provider="scholarpack"
      bind:isButtonLoading={isButtonLoading['ScholarPack']}
      on:select={onMisSelect.bind(this, 'ScholarPack')} />
      <ProviderBlock
      provider="arbor"
      bind:isButtonLoading={isButtonLoading['Arbor']}
      on:select={onMisSelect.bind(this, 'Arbor')} />   
  </div>
  <br />
  <div class="row">   
    <ProviderBlock
      provider="bromcom"
      bind:isButtonLoading={isButtonLoading['BromCom']}
      on:select={onMisSelect.bind(this, 'BromCom')} />
      <ProviderBlock
      provider="pupilasset"
      bind:isButtonLoading={isButtonLoading['PupilAsset']}
      on:select={onMisSelect.bind(this, 'PupilAsset')} />
  </div>
  <br />
  <div class="row">
    <ProviderBlock provider="simsprimary" bind:isButtonLoading={isButtonLoading['SIMSPrimary']} on:select={onMisSelect.bind(this, 'SIMSPrimary')} />   
  </div>
    
{:else}
  <div class="row">
    <ProviderBlock
      showChange={true}
      provider={$ProviderName}
      on:select={() => Router.route(`/app/import/step2`, false)}
      on:change={() => (showConfirm = true)} />
  </div>
{/if}
<Confirm
  showModal={showConfirm}
  on:confirm={onChangeMIS}
  sizeClass={''}
  targetClass="change-mis">
  <div slot="header">
    <h4>Change of MIS</h4>
  </div>
  <div slot="content">
    <p>Proceeding will reset your school’s import configuration and further data will not be imported until you have completed the configuration with your new MIS. </p> 
    <p>Please confirm you wish to proceed.</p> 
  </div>
</Confirm>
